import axios from "./HTTP";

export default {
  getTimeclockLocations(params, callback, errorCallback) {
    axios
      .get("/api/reports/timeclocks.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getGeoReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/geo.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getFulfillment(params, callback, errorCallback) {
    axios
      .get("/api/reports/fulfillment.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getCertificationsReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/certifications.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getEmployeesUpcoming(params, callback, errorCallback) {
    axios
      .get("/api/reports/employees_upcoming.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getEmployeeHours(params) {
    return axios.get("/api/reports/employee-hours.json", { params });
  },

  getWorksiteHours(params) {
    return axios.get("/api/reports/worksite-hours.json", { params });
  },

  getTopClients(params, callback, errorCallback) {
    axios
      .get("/api/reports/top_clients.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getShiftReviews(params, callback, errorCallback) {
    axios
      .get("/api/reports/shift_reviews.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getTimeclockAllLocations(params, callback, errorCallback) {
    axios
      .get("/api/reports/timeclocks.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getPayrollReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/payroll.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getBillingReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/billing.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getClientFulfillmentReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/client-fulfillment.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getClientLocationFulfillmentReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/client-location-fulfillment.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getManagerFulfillmentReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/manager-fulfillment.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getEmployeeShiftCountReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/employee-shift-count.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getEmployeeHoursAtLocation(params, callback, errorCallback) {
    axios
      .get("/api/reports/employee-hours-at-location.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getTimeclockSingleLocation(params, callback, errorCallback) {
    axios
      .get("/api/reports/timeclocks_at.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getCurrentlyWorking(params, callback, errorCallback) {
    axios
      .get("/api/reports/currently_working.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getContactReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/contact_report.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getClientTimeOrdered(params, callback, errorCallback) {
    axios
      .get("/api/reports/client_time_ordered.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getAllTimeOrdered(params, callback, errorCallback) {
    axios
      .get("/api/reports/all_time_ordered.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getShiftCancellations(params, callback, errorCallback) {
    axios
      .get("/api/reports/shift_cancellations.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getBirthdaysAnniversaries(params, callback, errorCallback) {
    axios
      .get("/api/reports/birthdays_anniversaries.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getTaskReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/tasks.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getReferralReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/referrals.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getCommLogReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/comm-log.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },

  getIPAddressLogReport(params, callback, errorCallback) {
    axios
      .get("/api/reports/ipaddress-log.json", { params: params })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
      });
  },
};
